var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconArrowDownRounded = function SvgIconArrowDownRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "icon_arrow_down_rounded_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_arrow_down_rounded_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5E6574",
    d: "M9.996 12.75a.756.756 0 0 1-.281-.052.691.691 0 0 1-.236-.156L5.528 8.59a.705.705 0 0 1-.226-.538.769.769 0 0 1 .24-.531.73.73 0 0 1 1.062 0L10 10.938l3.417-3.417a.693.693 0 0 1 .53-.219.769.769 0 0 1 .532.24.73.73 0 0 1-.007 1.068l-3.951 3.932a.756.756 0 0 1-.525.208Z"
  }))));
};
export default SvgIconArrowDownRounded;